import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

interface NotificationSettings {
  email: boolean;
  sms: boolean;
  push: boolean;
  studentSubmissions: boolean;
  parentMessages: boolean;
  adminAnnouncements: boolean;
  gradeReminders: boolean;
  attendanceAlerts: boolean;
}

interface ProfileData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  subject: string;
  department: string;
  employeeId: string;
  bio: string;
}

const TeacherSettings = () => {
  const routes = all_routes;
  const [activeSection, setActiveSection] = useState("profile");

  const [profileData, setProfileData] = useState<ProfileData>({
    firstName: "Sarah",
    lastName: "Johnson",
    email: "sarah.johnson@school.edu",
    phone: "+1 234 567 8900",
    subject: "Mathematics",
    department: "Science & Mathematics",
    employeeId: "TCH001",
    bio: "Passionate mathematics teacher with 8 years of experience in secondary education.",
  });

  const [notifications, setNotifications] = useState<NotificationSettings>({
    email: true,
    sms: false,
    push: true,
    studentSubmissions: true,
    parentMessages: true,
    adminAnnouncements: true,
    gradeReminders: false,
    attendanceAlerts: true,
  });

  const [language, setLanguage] = useState("en");
  const [theme, setTheme] = useState("light");

  const handleProfileSave = () => {
    // TODO: Save profile API call
    alert("Profile updated successfully!");
  };

  const handleNotificationSave = () => {
    // TODO: Save notification preferences API call
    alert("Notification settings updated!");
  };

  const renderProfileSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Profile Information</h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">First Name</label>
            <input
              type="text"
              className="form-control"
              value={profileData.firstName}
              onChange={(e) =>
                setProfileData({ ...profileData, firstName: e.target.value })
              }
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Last Name</label>
            <input
              type="text"
              className="form-control"
              value={profileData.lastName}
              onChange={(e) =>
                setProfileData({ ...profileData, lastName: e.target.value })
              }
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Email</label>
            <input
              type="email"
              className="form-control"
              value={profileData.email}
              onChange={(e) =>
                setProfileData({ ...profileData, email: e.target.value })
              }
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Phone</label>
            <input
              type="tel"
              className="form-control"
              value={profileData.phone}
              onChange={(e) =>
                setProfileData({ ...profileData, phone: e.target.value })
              }
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Subject</label>
            <select
              className="form-select"
              value={profileData.subject}
              onChange={(e) =>
                setProfileData({ ...profileData, subject: e.target.value })
              }
            >
              <option value="Mathematics">Mathematics</option>
              <option value="Physics">Physics</option>
              <option value="Chemistry">Chemistry</option>
              <option value="Biology">Biology</option>
              <option value="English">English</option>
              <option value="History">History</option>
              <option value="Geography">Geography</option>
              <option value="Art">Art</option>
              <option value="Physical Education">Physical Education</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Department</label>
            <input
              type="text"
              className="form-control"
              value={profileData.department}
              onChange={(e) =>
                setProfileData({ ...profileData, department: e.target.value })
              }
            />
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Employee ID</label>
            <input
              type="text"
              className="form-control"
              value={profileData.employeeId}
              disabled
            />
          </div>
          <div className="col-12 mb-3">
            <label className="form-label">Bio</label>
            <textarea
              className="form-control"
              rows={3}
              value={profileData.bio}
              onChange={(e) =>
                setProfileData({ ...profileData, bio: e.target.value })
              }
            />
          </div>
        </div>
        <button className="btn btn-primary" onClick={handleProfileSave}>
          Save Changes
        </button>
      </div>
    </div>
  );

  const renderNotificationSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Notification Preferences</h5>
      </div>
      <div className="card-body">
        {/* Delivery Methods */}
        <div className="mb-4">
          <h6 className="mb-3">Delivery Methods</h6>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.email}
              onChange={(e) =>
                setNotifications({ ...notifications, email: e.target.checked })
              }
            />
            <label className="form-check-label">Email Notifications</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.sms}
              onChange={(e) =>
                setNotifications({ ...notifications, sms: e.target.checked })
              }
            />
            <label className="form-check-label">SMS Notifications</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.push}
              onChange={(e) =>
                setNotifications({ ...notifications, push: e.target.checked })
              }
            />
            <label className="form-check-label">Push Notifications</label>
          </div>
        </div>

        {/* Notification Types */}
        <div className="mb-4">
          <h6 className="mb-3">Notification Types</h6>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.studentSubmissions}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  studentSubmissions: e.target.checked,
                })
              }
            />
            <label className="form-check-label">Student Submissions</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.parentMessages}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  parentMessages: e.target.checked,
                })
              }
            />
            <label className="form-check-label">Parent Messages</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.adminAnnouncements}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  adminAnnouncements: e.target.checked,
                })
              }
            />
            <label className="form-check-label">Admin Announcements</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.gradeReminders}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  gradeReminders: e.target.checked,
                })
              }
            />
            <label className="form-check-label">Grade Entry Reminders</label>
          </div>
          <div className="form-check mb-2">
            <input
              className="form-check-input"
              type="checkbox"
              checked={notifications.attendanceAlerts}
              onChange={(e) =>
                setNotifications({
                  ...notifications,
                  attendanceAlerts: e.target.checked,
                })
              }
            />
            <label className="form-check-label">Attendance Alerts</label>
          </div>
        </div>

        <button className="btn btn-primary" onClick={handleNotificationSave}>
          Save Preferences
        </button>
      </div>
    </div>
  );

  const renderAppearanceSettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Appearance & Language</h5>
      </div>
      <div className="card-body">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label className="form-label">Language</label>
            <select
              className="form-select"
              value={language}
              onChange={(e) => setLanguage(e.target.value)}
            >
              <option value="en">English</option>
              <option value="es">Spanish</option>
              <option value="fr">French</option>
              <option value="de">German</option>
            </select>
          </div>
          <div className="col-md-6 mb-3">
            <label className="form-label">Theme</label>
            <select
              className="form-select"
              value={theme}
              onChange={(e) => setTheme(e.target.value)}
            >
              <option value="light">Light</option>
              <option value="dark">Dark</option>
              <option value="auto">Auto</option>
            </select>
          </div>
        </div>
        <button className="btn btn-primary">Apply Changes</button>
      </div>
    </div>
  );

  const renderSecuritySettings = () => (
    <div className="card">
      <div className="card-header">
        <h5 className="card-title mb-0">Security Settings</h5>
      </div>
      <div className="card-body">
        <div className="mb-4">
          <h6 className="mb-3">Change Password</h6>
          <div className="row">
            <div className="col-md-6 mb-3">
              <label className="form-label">Current Password</label>
              <input type="password" className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">New Password</label>
              <input type="password" className="form-control" />
            </div>
            <div className="col-md-6 mb-3">
              <label className="form-label">Confirm New Password</label>
              <input type="password" className="form-control" />
            </div>
          </div>
          <button className="btn btn-warning">Update Password</button>
        </div>

        <div className="mb-4">
          <h6 className="mb-3">Two-Factor Authentication</h6>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" />
            <label className="form-check-label">
              Enable Two-Factor Authentication
            </label>
          </div>
          <small className="text-muted">
            Add an extra layer of security to your account
          </small>
        </div>

        <div className="mb-4">
          <h6 className="mb-3">Session Management</h6>
          <button className="btn btn-outline-danger">
            Sign Out All Devices
          </button>
          <small className="text-muted d-block mt-2">
            This will sign you out of all devices except this one
          </small>
        </div>
      </div>
    </div>
  );

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Settings</h3>
              <p className="text-muted mb-0">
                Manage your account preferences and settings
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-3">
              <div className="card">
                <div className="card-body">
                  <nav className="nav nav-pills flex-column">
                    <button
                      className={`nav-link text-start ${
                        activeSection === "profile" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("profile")}
                    >
                      <i className="ti ti-user me-2"></i>
                      Profile
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "notifications" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("notifications")}
                    >
                      <i className="ti ti-bell me-2"></i>
                      Notifications
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "appearance" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("appearance")}
                    >
                      <i className="ti ti-palette me-2"></i>
                      Appearance
                    </button>
                    <button
                      className={`nav-link text-start ${
                        activeSection === "security" ? "active" : ""
                      }`}
                      onClick={() => setActiveSection("security")}
                    >
                      <i className="ti ti-shield me-2"></i>
                      Security
                    </button>
                  </nav>
                </div>
              </div>
            </div>
            <div className="col-md-9">
              {activeSection === "profile" && renderProfileSettings()}
              {activeSection === "notifications" &&
                renderNotificationSettings()}
              {activeSection === "appearance" && renderAppearanceSettings()}
              {activeSection === "security" && renderSecuritySettings()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherSettings;
